module.exports = __webpack_public_path__ + "static/Intro-305d90e9967d530db6ebc0775ae40541.png";